import { PapiDeviation } from '@wix/da-papi-types';
import { useCurrentUser } from './useCurrentUser';
import { isDeviationAuthor } from '../../DeviationViews/_helpers';

/** True if the deviation was created by the currently logged in user (false if logged-out) */
export function useIsCurrentUserDeviationAuthor(
  deviation: PapiDeviation
): boolean {
  return isDeviationAuthor(deviation, useCurrentUser());
}
